import { Overlay, OverlayProps } from './Overlay';

export interface DialogProps extends OverlayProps {
    size?: 'md' | 'lg';
}

/** Centred dialog from 640 px, bottom sheet below. Focus is trapped; Esc and scrim close unless `busy`. */
export const Dialog = (props: DialogProps) => <Overlay variant="dialog" {...props} />;
